import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("psr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function apiError(e) {
  return formatApiErrorDetail(e?.response?.data?.detail) || e?.message || "Request failed";
}

export function trackEvent(event, props = {}) {
  api.post("/events", { event, props }).catch(() => {});
}

export const FRAMEWORK_LABELS = {
  CRA: "EU CRA",
  IEC62443_4_1: "IEC 62443-4-1",
  IEC62443_4_2: "IEC 62443-4-2",
  EU_MR: "EU Machinery Reg.",
  UKCA: "UKCA (GB route)",
  UK_PSTI: "UK PSTI",
};

export const FRAMEWORK_KEYS = ["CRA", "IEC62443_4_1", "IEC62443_4_2", "EU_MR", "UKCA", "UK_PSTI"];

export const STATUS_LABELS = {
  applicable: "Applicable",
  limited: "Limited applicability",
  not_applicable: "Not applicable based on current product profile",
};

export const SEVERITY_STYLES = {
  critical: "bg-rose-50 text-rose-700 border-rose-200",
  high: "bg-amber-50 text-amber-700 border-amber-200",
  medium: "bg-teal-50 text-teal-700 border-teal-200",
  low: "bg-slate-100 text-slate-600 border-slate-200",
};
